import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bad39a58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "software-name-wrapper"
}
const _hoisted_2 = { class: "software-name" }
const _hoisted_3 = {
  key: 0,
  class: "ratio-wrapper"
}
const _hoisted_4 = { class: "ratio-text" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { reactive, ref, onMounted, nextTick, computed, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'

import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import {
  SoftwareViewService,
  SoftwareUsageData,
  SoftwareUsageReq,
} from '../software-view/software-view.service'
import { SoftManageService } from '../../service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  FormSize,
  FormType,
  ObjectFormItem,
  DateType,
} from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { ServicePermissionService } from '@/services/service-permission.service'
import { formatDuration, formatTimeStamp } from '@/utils/time'
import dayjs from 'dayjs'
import { useParseTime } from '@/hooks'
import RangeSetting from '@/views/dashboard/manage/software-usage/_components/range-setting/range-setting.vue'

export type SoftwareUsageListPreset = 'all' | 'todayActive' | 'idle'


export default /*#__PURE__*/_defineComponent({
  __name: 'software-usage-list',
  props: {
    viewMode: { default: TableViewMode.preview },
    hasPermission: { type: Boolean, default: true },
    dateRange: { default: () =>
      [dayjs().subtract(3, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')] as [string, string] },
    listPreset: { default: 'all' },
    initialSoftGroupId: { default: undefined },
    initialSoftName: { default: '' }
  },
  emits: ['viewAll', 'detail'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
function threeMonthRange(): [string, string] {
  return [dayjs().subtract(3, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
}

/** 活跃/已安装，用于安装率进度条（0–100） */
function activeInstallPercent(row: { today_active_count?: number; install_total_count?: number }): number {
  const install = row.install_total_count ?? 0
  if (!install) return 0
  return Math.min(100, Number((((row.today_active_count ?? 0) / install) * 100).toFixed(1)))
}

const props = __props

const emits = __emit

const injector = useReflectiveInjector([SoftManageService, SoftwareViewService])
const softManageService = injector.get(SoftManageService)
const softwareService = injector.get(SoftwareViewService)
const servicePermissionService = injector.get(ServicePermissionService)
const hasPermission = props.hasPermission

function dataApi(params: any) {
  const start = queryParams.start_time != null ? Number(queryParams.start_time) : 0
  const end = queryParams.end_time != null ? Number(queryParams.end_time) : 0
  return softManageService.getSoftmgrUserecordSoftList({
    page: params.page ?? queryParams.page,
    limit: params.limit ?? queryParams.limit,
    start_time: start,
    end_time: end,
    soft_name: queryParams.soft_name || undefined,
    soft_group_id: queryParams.soft_group_id,
    sort: queryParams.sort,
    asc: queryParams.asc,
    ...(queryParams.idle_only === 1 ? { idle_only: 1 } : {})
  }).then(res => ({
    list: res.list || [],
    total: res.total
  }))
}

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const rangeSettingVisible = ref(false)
const total = computed(() => tableRef.value?.total || 0)

function handleRangeSettingSaved() {
  void refreshList()
}

function baselineRangeForPreset(
  preset: SoftwareUsageListPreset,
  fallbackRange: [string, string]
): [string, string] | [] {
  if (preset === 'todayActive') {
    const d = dayjs().format('YYYY-MM-DD')
    return [d, d]
  }
  if (preset === 'idle') {
    return []
  }
  return fallbackRange
}

function sortForPreset(preset: SoftwareUsageListPreset): { sort: string; asc: boolean } {
  if (preset === 'todayActive') {
    return { sort: 'today_active_count', asc: false }
  }
  if (preset === 'idle') {
    return { sort: 'last_active_time', asc: true }
  }
  return { sort: 'avg_use_count', asc: false }
}

const initialRange: [string, string] | [] =
  props.dateRange?.length === 2 ? props.dateRange : baselineRangeForPreset(props.listPreset, threeMonthRange())
const [initialStartTime, initialEndTime] = useParseTime(initialRange as string[])
const initialSort = sortForPreset(props.listPreset)

const queryParams = reactive<
  SoftwareUsageReq & { dateRange?: [string, string]; soft_group_id?: number; idle_only?: number }
>({
  soft_name: (props.initialSoftName && String(props.initialSoftName).trim()) || '',
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  sort: initialSort.sort,
  asc: initialSort.asc,
  dateRange: initialRange.length === 2 ? initialRange : ([] as unknown as [string, string]),
  start_time: initialStartTime != null ? String(initialStartTime) : undefined,
  end_time: initialEndTime != null ? String(initialEndTime) : undefined,
  soft_group_id:
    props.initialSoftGroupId != null && Number.isFinite(props.initialSoftGroupId)
      ? props.initialSoftGroupId
      : undefined,
  idle_only: props.listPreset === 'idle' ? 1 : undefined
})

const softGroupDictData = ref<Array<{ group_id: number; group_name: string }>>([])
const softGroupObj = ref<Record<number, string>>({})
const filterFormColumns = computed<ObjectFormItem<typeof queryParams, 'soft_group_id' | 'dateRange'>>(() => {
  void locale.value
  return {
    dateRange: {
      prop: 'dateRange',
      label: t('genuineSoftwareUsage.timeRange'),
      type: FormType.Date,
      dateType: DateType.DateRange,
      colOpt: { style: 'flex: 0 0 260px' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      dateOpt: {
        clearable: props.listPreset === 'idle',
        'value-format': 'YYYY-MM-DD',
        'start-placeholder': t('common.startDate'),
        'end-placeholder': t('common.endDate')
      },
      events: {
        change: (val: string[]) => {
          if (val?.length === 2) {
            const [s, e] = useParseTime(val)
            queryParams.start_time = s != null ? String(s) : undefined
            queryParams.end_time = e != null ? String(e) : undefined
          } else {
            queryParams.start_time = undefined
            queryParams.end_time = undefined
          }
          queryParams.page = 1
          void refreshList()
        }
      }
    },
    soft_group_id: {
      prop: 'soft_group_id',
      label: t('softwareUsage.softCategory'),
      type: FormType.Select,
      colOpt: { style: 'flex: 0 0 150px' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      selectOpt: { clearable: true },
      dictData: softGroupDictData.value,
      props: { label: 'group_name', value: 'group_id' },
      events: {
        change: (val: number | undefined) => {
          queryParams.soft_group_id = val
          queryParams.page = 1
          void refreshList()
        }
      }
    }
  }
})

/** 筛选项与 software-view 等一致：拉取全量软件分组（不依赖时段统计接口，避免 dictData 为空） */
async function loadSoftCategoryOptions() {
  try {
    const res = await softwareService.softGroup()
    softGroupDictData.value = res.list || []
    softGroupObj.value = res.list.reduce((acc, item) => {
      acc[item.group_id] = item.group_name
      return acc
    }, {})
  } catch (e) {
    console.error('加载软件分类选项失败:', e)
    softGroupDictData.value = []
  }
}

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: t('portManage.operation'), width: 100, fixed: 'right' },
    actionButtons: () => [
      { name: t('portManage.detail'), type: 'detail', opt: { size: FormSize.Small, text: true, type: 'text' } }
    ]
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
    path: 'list',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: 'soft_id',
    selection: false,
    showTip: false,
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      { prop: 'soft_name', label: t('softwareManage.softwareName'), columnOpt: { minWidth: 200 } },
      { prop: 'soft_type', label: t('softwareManage.softType'), formatter: (row: SoftwareUsageData, val: number) => softGroupObj.value[val] || '--' },
      { prop: 'active_install_ratio', label: t('softwareUsage.activeInstallRatio'), columnOpt: { minWidth: 180 } },
      { prop: 'avg_duration', label: t('softwareUsage.avgDuration'), columnOpt: { minWidth: 140 } },
      { prop: 'avg_use_count', label: t('softwareUsage.avgUseCount'), columnOpt: { minWidth: 140 }, sortable: 'custom' },
      { prop: 'last_active_time', label: t('softwareUsage.lastActiveTime'), columnOpt: { minWidth: 180 }, formatter: (_row: any, value: number | string | null | undefined) => (value != null && value !== '' ? formatTimeStamp(String(value), 'YYYY-MM-DD HH:mm') : '--') }
    ],
    totalPath: 'total',
    tableActOpt: tableActOpt.value
  }
})

async function handleSearch(value: string) {
  queryParams.soft_name = value
  queryParams.page = 1
  await refreshList()
}

async function handleQuery(form?: Partial<typeof queryParams>) {
  const nextForm = (form ?? {}) as Partial<typeof queryParams>
  if (nextForm.dateRange?.length === 2) {
    const [s, e] = useParseTime(nextForm.dateRange)
    nextForm.start_time = s != null ? String(s) : undefined
    nextForm.end_time = e != null ? String(e) : undefined
  } else {
    nextForm.start_time = undefined
    nextForm.end_time = undefined
  }
  Object.assign(queryParams, nextForm)
  queryParams.page = 1
  if (props.listPreset === 'idle') {
    queryParams.idle_only = 1
  }
  await refreshList()
}

function handleReset() {
  const range = baselineRangeForPreset(props.listPreset, threeMonthRange())
  const [s, e] = useParseTime(range as string[])
  const sortParams = sortForPreset(props.listPreset)
  queryParams.soft_name = ''
  queryParams.soft_group_id = undefined
  queryParams.dateRange = range.length === 2 ? range : ([] as unknown as [string, string])
  queryParams.start_time = s != null ? String(s) : undefined
  queryParams.end_time = e != null ? String(e) : undefined
  queryParams.sort = sortParams.sort
  queryParams.asc = sortParams.asc
  queryParams.page = 1
  queryParams.idle_only = props.listPreset === 'idle' ? 1 : undefined
  void refreshList()
}

function handleAction({ type, rowItem }: { type: string; rowItem: SoftwareUsageData }) {
  if (type === 'detail') {
    handleDetail(rowItem)
  }
}

function handleDetail(item: SoftwareUsageData) {
  emits('detail', item)
}

function download(type: 0 | 1) {
  softwareService.download(type, {
    soft_name: queryParams.soft_name,
    soft_group_id: queryParams.soft_group_id,
    start_time: queryParams.start_time != null ? String(queryParams.start_time) : undefined,
    end_time: queryParams.end_time != null ? String(queryParams.end_time) : undefined,
    ...(queryParams.idle_only === 1 ? { idle_only: 1 } : {})
  } as SoftwareUsageReq, t('softwareUsage.exportSoftwareView'))
}

watch(locale, () => {
  void loadSoftCategoryOptions()
})

watch(
  () => props.dateRange,
  async (v) => {
    if (props.listPreset === 'idle' && (!v || v.length !== 2)) {
      queryParams.dateRange = [] as unknown as [string, string]
      queryParams.start_time = undefined
      queryParams.end_time = undefined
      queryParams.soft_group_id = undefined
      queryParams.idle_only = 1
      queryParams.page = 1
      await refreshList()
      return
    }
    if (!v?.length || v.length !== 2) return
    const [s, e] = useParseTime(v)
    queryParams.dateRange = v as [string, string]
    queryParams.start_time = s != null ? String(s) : undefined
    queryParams.end_time = e != null ? String(e) : undefined
    queryParams.soft_group_id = undefined
    queryParams.page = 1
    queryParams.idle_only = props.listPreset === 'idle' ? 1 : undefined
    await refreshList()
  },
  { deep: true }
)

onMounted(async () => {
  if (!hasPermission) return
  await nextTick()
  await loadSoftCategoryOptions()
  void refreshList()
})

__expose({
  tableRef,
  getList: () => void refreshList(),
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      tableOpt: tableOpt.value,
      tableActOpt: tableActOpt.value,
      firstLoading: false,
      "has-permission": _unref(hasPermission),
      api: dataApi,
      modelValue: queryParams,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams) = $event)),
      pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
      onHandleAction: handleAction
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: queryParams,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
          "form-columns": filterFormColumns.value,
          disabled: !_unref(hasPermission),
          "show-search": true,
          "sync-search-from-field": "soft_name",
          "search-placeholder": _ctx.$t('softwareManage.searchPlaceholderSoft'),
          "popover-threshold": 2,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              disabled: !_unref(hasPermission),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (rangeSettingVisible.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('softwareUsage.rangeSetting')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(ExportDropdown, {
              "has-permission": _unref(hasPermission),
              onExport: download
            }, null, 8, ["has-permission"]),
            (props.viewMode === _unref(TableViewMode).preview)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  disabled: !_unref(hasPermission),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('viewAll')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
      ]),
      soft_name: _withCtx(({ row }: { row?: SoftwareUsageData & { soft_group_name?: string } }) => [
        row
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(row.soft_name), 1),
              (row.soft_group_name)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    size: "small",
                    type: "success",
                    class: "software-tag"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.soft_group_name), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      active_install_ratio: _withCtx(({ row }: { row?: SoftwareUsageData & { today_active_count?: number; install_total_count?: number } }) => [
        row
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_progress, {
                class: "install-rate-progress",
                percentage: activeInstallPercent(row),
                "stroke-width": 8,
                "show-text": false
              }, null, 8, ["percentage"]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(row.today_active_count || 0) + "/" + _toDisplayString(row.install_total_count || 0), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      avg_duration: _withCtx(({ row }: { row?: SoftwareUsageData }) => [
        row
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(formatDuration)((row.avg_duration ?? 0) * 60)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))
      ]),
      avg_use_count: _withCtx(({ row }: { row?: SoftwareUsageData }) => [
        row
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.avg_use_count ?? 0), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "0"))
      ]),
      _: 1
    }, 8, ["tableOpt", "tableActOpt", "has-permission", "modelValue"]),
    _createVNode(RangeSetting, {
      modelValue: rangeSettingVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rangeSettingVisible).value = $event)),
      onUpdate: handleRangeSettingSaved
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})